import * as api from "api/Knowledge";
import { FeedItemDto } from "models/ApiModels";
import { PublicationActionType } from "models/ApiEnums";
import { SnackbarShowMessage } from "components/SnackbarProvider/Snackbar";

/////////////////////////////////////////////////////////////////////////////////////

export class CardCommonActions {

    constructor(
        private onUpdateFeedData: (item: DeepPartial<FeedItemDto>) => void,
        private showMessage: SnackbarShowMessage
    ) {
    }

    ///

    public inApprovalMode(item: FeedItemDto) {
        return item.action && (item.action.actionType == PublicationActionType.ApproveSuggestion || item.action.actionType == PublicationActionType.ApproveWorkflow);
    }

    ///

    public expandBestAnswerText(item: FeedItemDto, textExpanded: boolean) {

        const d = { ...item };

        if (d.bestAnswer == null)
            return;

        if (textExpanded) {

            api.getPublicationFullContent(d.bestAnswer.publicationId)
                .then((fullContent) => {

                    if (fullContent) {
                        d.bestAnswer.body.fullContentLoaded = textExpanded;
                        d.bestAnswer.body.fullContent = fullContent;
                    }

                    this.onUpdateFeedData(d);
                })
                .catch(() => {
                    this.onUpdateFeedData(d);
                });
        }
        else {
            d.bestAnswer.body.fullContentLoaded = textExpanded;
            this.onUpdateFeedData(d);
        }
    }


    ///

    public expandText(item: FeedItemDto, textExpanded: boolean) {

        const d = { ...item };

        if (textExpanded && d.body.fullContent == null) {

            api.getPublicationFullContent(item.publicationId)
                .then((fullContent) => {
                    d.body.fullContentLoaded = textExpanded;
                    d.body.fullContent = fullContent || "";
                    this.onUpdateFeedData(d);
                })
                .catch((error) => {
                    this.onUpdateFeedData(d);
                });
        }
        else {
            d.body.fullContentLoaded = textExpanded;
            this.onUpdateFeedData(d);
        }
    }

    ///

    public viewLater = (publicationId: string, check: boolean) => {

        api.postSeeLater({ publicationId, check })
            .then(() => {
                this.onUpdateFeedData(
                    {
                        publicationId,
                        interaction: { inViewLaterList: check }
                    }
                );
            });
    };
}
